var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevel7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 94,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 94c25.957 0 47-21.043 47-47S79.957 0 54 0 7 21.043 7 47s21.043 47 47 47Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.6 17.4H93.7c-11.9 0-22.1 7.4-26.2 17.9l7.6 15.9h7.3c6.5 0 11.8-5.3 11.8-11.8l-.2-.5c4.1-1.9 7-6 7-10.8 0 0 5.6-4.2 5.6-10.7Z",
    fill: "#8DD9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6 39.4c0 6.5-5.3 11.8-11.8 11.8h-7.3m-7.7-15.9C72 24.8 82.1 17.4 94.1 17.4H107c0 6.5-5.3 11.8-11.8 11.8h-5.1l-22.3 6.1Zm33.6-7.2c0 6.5-5.3 11.8-11.8 11.8h-5.1l16.9-11.8Z",
    stroke: "#25AFE5",
    strokeWidth: 2.815,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.4H2c0 6.5 5.6 10.7 5.6 10.7 0 4.8 2.9 8.9 7 10.8l-.2.5c0 6.5 5.3 11.8 11.8 11.8h7.3l7.6-15.9c-4-10.5-14.2-17.9-26.1-17.9Z",
    fill: "#8DD9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 39.4c0 6.5 5.3 11.8 11.8 11.8h7.3m7.7-15.9c-4.1-10.5-14.3-17.9-26.2-17.9h-13c0 6.5 5.3 11.8 11.8 11.8h5.1l22.3 6.1ZM8 28.1c0 6.5 5.3 11.8 11.8 11.8h5.1L8 28.1Z",
    stroke: "#25AFE5",
    strokeWidth: 2.815,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 80.4c16.016 0 29-12.984 29-29s-12.984-29-29-29-29 12.984-29 29 12.984 29 29 29Z",
    fill: "#D5EFF7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m56.2 33.6 4.2 8.5c.3.5.8.9 1.4 1l9.4 1.4c1.5.2 2.1 2.1 1 3.2l-6.8 6.6c-.4.4-.6 1-.5 1.6l1.6 9.3c.3 1.5-1.3 2.7-2.7 1.9l-8.4-4.4c-.5-.3-1.2-.3-1.7 0l-8.4 4.4c-1.4.7-2.9-.4-2.7-1.9l1.6-9.3c.1-.6-.1-1.2-.5-1.6l-6.8-6.6c-1.1-1.1-.5-2.9 1-3.2l9.4-1.4c.6-.1 1.1-.5 1.4-1l4.2-8.5c.6-1.3 2.6-1.3 3.3 0Z",
    fill: "#FFD41F",
    stroke: "#F4C500",
    strokeWidth: 2.022
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel7);
export default __webpack_public_path__ + "static/media/level7.3cf169e6.svg";
export { ForwardRef as ReactComponent };